<template>
    <div class="table-comparison">
        <div class="container">
            <div class="table-responsive">
                <table class="table">
                    <div class="row">
                        <div class="col-md-3 col-sm-4 col-xs-8">
                            <div class="head">
                                <div class="table-comparison__head__content">
                                    <div class="table-comparison--image">
                                        <img src="/images/amd-promo/ryzen.png" class="ryzen" alt="Ryzen Processor">
                                    </div>
                                    <h6>AMD Ryzen™ <br> Processors</h6>
                                </div>
                            </div>
                            <div class="content">
                                <ul>
                                    <li>AMD Ryzen™ 9 3000 Series</li>
                                    <li>AMD Ryzen™ 7 3800X</li>
                                    <li>AMD Ryzen™ 7 3700X</li>
                                    <li>AMD Ryzen™ 5 3600X</li>
                                    <li>AMD Ryzen™ 7 2700X</li>
                                    <li>AMD Ryzen™ 7 2700</li>
                                    <li>AMD Ryzen™ 5 3600</li>
                                    <li>AMD Ryzen™ 5 3400G</li>
                                    <li>AMD Ryzen™ 5 2000 Series</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-12">
                            <div class="head head-columns">
                                <div class="table-comparison__head__content">
                                    <div class="outer-worlds">
                                        <div class="table-comparison--image">
                                            <img src="/images/amd-promo/the-outer-worlds.png" alt="The Outer Worlds">
                                        </div>
                                        <h6>The Outer Worlds</h6>
                                    </div>
                                    <div class="borderlands">
                                        <div class="table-comparison--image">
                                            <img src="/images/amd-promo/borderlands-3.png" alt="Borderlands 3">
                                        </div>
                                        <h6>Borderlands 3</h6>
                                    </div>
                                </div>
                            </div>
                            <div class="content">
                                <ul>
                                    <li>Get Both Games (2 Games)</li>
                                    <li>Get Both Games (2 Games) </li>
                                    <li>Choice of 1 Game</li>
                                    <li>Choice of 1 Game</li>
                                    <li>Choice of 1 Game</li>
                                    <li>Choice of 1 Game</li>
                                    <li>n/a</li>
                                    <li>n/a</li>
                                    <li>n/a</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-4 col-xs-8">
                            <div class="head">
                                <div class="table-comparison__head__content">
                                    <div class="table-comparison--image">
                                        <img src="/images/amd-promo/xbox-game-pass.png" alt="Xbox Game Pass for PC">
                                    </div>
                                    <h6>3 Months of Xbox <br> Game Pass for PC*</h6>
                                </div>
                            </div>
                            <div class="content">
                                <ul>
                                    <li>
                                        <img src="/images/icons/check-white.svg">
                                    </li>
                                    <li>
                                        <img src="/images/icons/check-white.svg">
                                    </li>
                                    <li>
                                        <img src="/images/icons/check-white.svg">
                                    </li>
                                    <li>
                                        <img src="/images/icons/check-white.svg">
                                    </li>
                                    <li>
                                        <img src="/images/icons/check-white.svg">
                                    </li>
                                    <li>
                                        <img src="/images/icons/check-white.svg">
                                    </li>
                                    <li>
                                        <img src="/images/icons/check-white.svg">
                                    </li>
                                    <li>
                                        <img src="/images/icons/check-white.svg">
                                    </li>
                                    <li>
                                        <img src="/images/icons/check-white.svg">
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TableComparison'
    }
</script>

<style lang="scss" scoped>
.table-comparison {
    background-color: black;
    padding: 70px 0px;

    .container {
        @media screen and (max-width: 991px) {
            padding: 0;
            margin: 0 -15px;
            width: auto;
        }
    }

    .table {
        .col-xs-8,
        .col-xs-12 {
            flex-shrink: 0;
        }

        .col-md-3,
        .col-sm-4,
        .col-xs-6 {
            padding: 0;
        }

        .col-md-6,
        .col-sm-6,
        .col-xs-12 {
            padding: 0 5px;
        }

        .row {
            margin: 0;
            display: flex;
        }
    }

    .table-responsive {
        border: none;

        @media screen and (max-width: 991px) {
            width: 100%;
            margin-bottom: 15px;
            overflow-y: hidden;
            -ms-overflow-style: -ms-autohiding-scrollbar;
        }
    }

    .head {
        height: 340px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;
        background-color: #151515;
        color: white;
        padding-bottom: 25px;

        .table-comparison__head__content {
            height: 245px;
            display: flex;
            justify-content: space-around;
            align-items: flex-start;
            flex-direction: column;
            align-items: center;
        }

        .table-comparison--image {
            height: 175px;
            margin-bottom: 15px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 20px;

            img {
                width: 100%;
            }
        }

        h6 {
            font-size: 21px;
            font-weight: bold;
            line-height: 26px;
            color: white;
            text-align: center;
            margin: 0;
        }
    }

    .head-columns {
        justify-content: space-around;
        flex-direction: row;
        align-items: flex-end;

        .table-comparison__head__content {
            flex-direction: row;
            align-items: flex-start;
        }

        .outer-worlds {
            margin-right: 60px;

            @media screen and (max-width: 991px) {
                margin-right: 40px;
            }
        }

        .outer-worlds,
        .borderlands {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
        }
    }

    .content {
        ul {
            list-style: none;
            padding: 0;
            margin: 0;

            li {
                height: 40px;
                font-size: 20px;
                color: white;
                display: flex;
                align-items: center;
                justify-content: center;

                @media screen and (max-width: 1200px) {
                    font-size: 16px;
                }

                &:nth-child(even) {
                    background-color: #151515;
                }
            }
        }
    }
}
</style>